export default defineAppConfig({
  ui: {
    tooltip: {
      // По умолчанию в @nuxt/ui: max-w-xs + truncate + h-6 — длинный текст не читается
      width: 'max-w-md sm:max-w-lg',
      base: '[@media(pointer:coarse)]:hidden h-auto min-h-0 max-h-none px-3 py-2 text-xs font-normal !whitespace-normal break-words text-left leading-relaxed relative',
    },
  },
})
